/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RefreshInstrumentLinkingOptionsRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/RefreshInstrumentLinkingOptions.pb'
import {RefreshInstrumentLinkingOptionsResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/RefreshInstrumentLinkingOptions.pb'


export const refreshInstrumentLinkingOptions = (request:RefreshInstrumentLinkingOptionsRequest, options?: CashRequestOptions) => post<RefreshInstrumentLinkingOptionsRequest, RefreshInstrumentLinkingOptionsResponse>("/2.0/cash/refresh-instrument-linking-options", request, {...options, rejectOnError: true })